import { useEffect, useState } from "react";
import axios from "axios";
import { DigestPanel } from "./DigestPanel";
import { TrackingSettingsForm, CapiTestCard } from "./TrackingSettingsForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const events = [
  { name: "PageView", when: "Ad ogni visita reale della landing, solo dopo consenso Marketing." },
  { name: "ViewContent", when: "Al click su un capo del catalogo, prima dell'apertura del form (nome, ID, categoria)." },
  { name: "Contact", when: "Al click su un canale di contatto (Instagram, LinkedIn) nel footer." },
  { name: "Lead", when: "Solo dopo il salvataggio del lead nel database. Browser (Pixel) + server (Conversions API) con lo stesso event_id: Meta deduplica e attribuisce anche su iOS." },
];

export const TrackingPanel = ({ token }) => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/settings`, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => setMeta(data));
  }, [token]);

  if (!meta) return <p className="font-sans-ui text-sm text-ink/50">Caricamento...</p>;

  return (
    <div className="grid lg:grid-cols-[1fr_1.1fr] gap-12" data-testid="tracking-panel">
      <TrackingSettingsForm token={token} meta={meta} onSaved={setMeta} />

      <div className="space-y-10">
        <CapiTestCard token={token} enabled={!!meta.capi_configured} />

        <div>
          <p className="font-sans-ui text-[10px] tracking-mega text-ink/40 mb-5">EVENTI CONFIGURATI</p>
          <ul className="border-t hairline">
            {events.map((ev) => (
              <li key={ev.name} className="grid grid-cols-[120px_1fr] gap-4 py-4 border-b hairline">
                <span className="font-sans-ui text-[12px] font-semibold text-ink">{ev.name}</span>
                <span className="font-sans-ui text-[13px] text-ink/65 leading-relaxed">{ev.when}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="font-sans-ui text-[13px] text-ink/65 leading-relaxed space-y-2">
          <p><span className="text-ink font-medium">Consenso GDPR.</span> Pixel e CAPI si attivano solo se il visitatore accetta la categoria "Marketing". Il consenso viene inviato insieme al lead: senza consenso il server non contatta Meta.</p>
          <p><span className="text-ink font-medium">Attribuzione.</span> Ogni lead salva UTM, referrer, landing URL, device, IP, timestamp, cookie _fbp/_fbc ed event_id.</p>
        </div>

        <DigestPanel token={token} />
      </div>
    </div>
  );
};
